import { render } from "./OrderConfirmationPending.vue?vue&type=template&id=e33e7a12"
import script from "./OrderConfirmationPending.vue?vue&type=script&lang=js"
export * from "./OrderConfirmationPending.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__